module.exports = __webpack_public_path__ + "static/media/cafe_noir.bdf29929.jpeg";